/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BonusGrantBatchPageVo } from './BonusGrantBatchPageVo';
import {
    BonusGrantBatchPageVoFromJSON,
    BonusGrantBatchPageVoFromJSONTyped,
    BonusGrantBatchPageVoToJSON,
    BonusGrantBatchPageVoToJSONTyped,
} from './BonusGrantBatchPageVo';

/**
 * 
 * @export
 * @interface ResponseBonusGrantBatchPageVo
 */
export interface ResponseBonusGrantBatchPageVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseBonusGrantBatchPageVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseBonusGrantBatchPageVo
     */
    message?: string;
    /**
     * 
     * @type {BonusGrantBatchPageVo}
     * @memberof ResponseBonusGrantBatchPageVo
     */
    data?: BonusGrantBatchPageVo;
}

/**
 * Check if a given object implements the ResponseBonusGrantBatchPageVo interface.
 */
export function instanceOfResponseBonusGrantBatchPageVo(value: object): value is ResponseBonusGrantBatchPageVo {
    return true;
}

export function ResponseBonusGrantBatchPageVoFromJSON(json: any): ResponseBonusGrantBatchPageVo {
    return ResponseBonusGrantBatchPageVoFromJSONTyped(json, false);
}

export function ResponseBonusGrantBatchPageVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseBonusGrantBatchPageVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : BonusGrantBatchPageVoFromJSON(json['data']),
    };
}

export function ResponseBonusGrantBatchPageVoToJSON(json: any): ResponseBonusGrantBatchPageVo {
    return ResponseBonusGrantBatchPageVoToJSONTyped(json, false);
}

export function ResponseBonusGrantBatchPageVoToJSONTyped(value?: ResponseBonusGrantBatchPageVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': BonusGrantBatchPageVoToJSON(value['data']),
    };
}

